module.exports = __webpack_public_path__ + "static/media/hacktheplanet.dea4856d.gif";